import axios from 'axios';

const getContactFields = async function() {
    try {
        const response = await axios.get('/app/fieldValueFunnel/contactFields');
        let data = parseResponse(response);

        data = Object.entries(data).map(([key, value]) => {
            return {
                label: value[0],
                value: key,
                isNumeric: value[1],
            };
        });

        return data;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};

const getFieldValueConfig = async function (fileBoxId) {
    try {
        const response = await axios.get(`/app/fieldValueFunnel/${fileBoxId}`);
        const data = parseResponse(response);

        if (!Array.isArray(data) || !data.length) {
            return [];
        }

        return data[0];
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};

const parseResponse = (response) => {
    if (response.status !== 200) throw Error(response.message);
    if (!response.data) return [];
    let list = response.data;

    if (typeof list !== 'object') {
        list = [];
    }

    return list;
};

const getConvrrtLandingPagesSites = async function() {
    try {
        const response = await axios.get('/app/convrrtLandingPageFunnel/sites');

        const landingPagesSites = response.data.sites;

        return Object.keys(landingPagesSites).map((key) => {
            return { label: landingPagesSites[key].name, value: landingPagesSites[key].id };
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};


const getConvrrtLandingPages = async function(pageId) {
    try {
        const response = await axios.get(`/app/convrrtLandingPageFunnel/sites/${pageId}/pages`);

        const landingPages = response.data.pages;

        return Object.keys(landingPages).map((key) => {
            const formId = landingPages[key].forms[0]?.id ?? landingPages[key].id;

            return { label: landingPages[key].name, value: formId };
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};

const getLeadBucketIdsByPageIds = async function(pageIds) {
    try {
        return await axios.post('/app/convrrtLandingPageFunnel/getLeadBucketFunnelMapByLeadBucketId', pageIds)
            .then((res) => {
                return res.data;
            });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};

const deleteLeadBucketIdsByIds = async function(funnelBucketIds) {
    try {
        await axios.post('/app/convrrtLandingPageFunnel/deleteLeadBucketFunnelMapById', funnelBucketIds);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
};

const searchTemplateGroups = async function(name) {
    try {
        const response = await axios.get(`/app/unlayerLandingPageFunnel/templateGroups/${name}`);
        const landingPages = response.data;

        return JSON.stringify(landingPages);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};

const loadUnlayerLandingPageOptions = async function() {
    try {
        const response = await axios.get('/app/unlayerLandingPageFunnel/loadTemplateGroups');
        const landingPages = response.data;

        return JSON.stringify(landingPages);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};

const getUnlayerFormOptions = async function(templateIds) {
    try {
        const response = await axios.get(`/app/unlayerLandingPageFunnel/getForms/${templateIds}`);
        const unlayerFormOptions = response.data;

        return JSON.stringify(unlayerFormOptions);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};

const getFormOptions = async function(templateGroupId) {
    try {
        const response = await axios.get(`/app/unlayerLandingPageFunnel/loadForms/${templateGroupId}`);
        const unlayerFormOptions = response.data;

        return JSON.stringify(unlayerFormOptions);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);

        return [];
    }
};

export const dataService = {
    getContactFields,
    getFieldValueConfig,
    getConvrrtLandingPagesSites,
    getConvrrtLandingPages,
    getLeadBucketIdsByPageIds,
    deleteLeadBucketIdsByIds,
    loadUnlayerLandingPageOptions,
    getUnlayerFormOptions,
    getFormOptions,
    searchTemplateGroups,
};
